import * as React from 'react';

import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@cold-ambulance/shadcn';

import { useUser } from '../firebase.tsx';
import { NavHeader } from './nav-header.tsx';
import { NavMain } from './nav-main.tsx';
import sidebarData from './sidebar-data.tsx';

function useSidebarData() {
  const { data: user } = useUser();

  return React.useMemo(() => {
    const userRoles = user?.roles?.map((roleLink) => roleLink.role.name) || [];
    return sidebarData.filter((item) => {
      if (!item.roles || item.roles.length === 0) {
        return true;
      }

      return item.roles.some((role) => userRoles.includes(role));
    });
  }, [user]);
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const sidebarData = useSidebarData();
  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <NavHeader />
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={sidebarData} />
      </SidebarContent>
    </Sidebar>
  );
}
